import AnimatedNumber from "@/components/simulator/AnimatedNumber";
import { fmtMoney } from "@/lib/simulator";

const COLOR_MAP = {
  orange: { dot: "#F97316", glow: "rgba(249,115,22,0.35)", grad: "from-orange-400 to-orange-200" },
  pink:   { dot: "#EC4899", glow: "rgba(236,72,153,0.35)", grad: "from-pink-400 to-pink-200" },
  purple: { dot: "#A855F7", glow: "rgba(168,85,247,0.35)", grad: "from-purple-400 to-purple-200" },
  sky:    { dot: "#38BDF8", glow: "rgba(56,189,248,0.35)", grad: "from-sky-300 to-cyan-200" },
};

export default function BonusCard({
  testId, title, subtitle, color = "orange", total = 0, totalOverride, rows = [], footer,
}) {
  const c = COLOR_MAP[color] || COLOR_MAP.orange;
  return (
    <div data-testid={testId} className="glass rounded-2xl p-5 card-hover">
      <div className="flex items-start justify-between gap-3">
        <div>
          <div className="flex items-center gap-2">
            <span className="h-2 w-2 rounded-full" style={{ background: c.dot, boxShadow: `0 0 12px ${c.glow}` }} />
            <h3 className="font-display text-lg font-semibold tracking-tight">{title}</h3>
          </div>
          <div className="mt-0.5 text-xs text-slate-400">{subtitle}</div>
        </div>
        <div className={`font-mono text-xl font-semibold text-transparent bg-clip-text bg-gradient-to-r ${c.grad}`}>
          {totalOverride ? totalOverride : <AnimatedNumber value={total} formatter={fmtMoney} />}
        </div>
      </div>

      <div className="mt-4 divide-y divide-white/[0.05]">
        {rows.map((r, i) => (
          <div key={i} className={`flex items-center justify-between py-2 text-sm ${r.muted ? "opacity-50" : ""}`}>
            <div>
              <div className="text-slate-200">{r.label}</div>
              <div className="text-[11px] text-slate-500">{r.sub}</div>
            </div>
            <div className="font-mono text-slate-100">{r.value}</div>
          </div>
        ))}
      </div>

      {footer && <div className="mt-3 text-[11px] text-slate-500 leading-relaxed">{footer}</div>}
    </div>
  );
}
